
import { Component, Vue } from "vue-property-decorator";
import logoImg from "./images/logo.png";
import codeImg from "./images/code.png";

@Component
export default class VFooter extends Vue {
  protected render() {
    return (
      <div class="vfooter">
        <div class="container top clear">
          {false && (
            <div class="left">
              <img src={logoImg} />
              <span>青创未来云赛事</span>
            </div>
          )}
          <div class="center clear">
            <div class="shortcut">
              <p>友情链接</p>
              <ul class="link-list">
                <li>
                  <a href="http://www.mohrss.gov.cn/" target="_blank">
                    中华人民共和国人力资源和社会保障部
                  </a>
                </li>
                <li>
                  <a href="http://www.zhzjs.org/" target="_blank">中华职业教育社</a>
                </li>
                <li>
                  <a href="http://jyt.fujian.gov.cn/" target="_blank">福建省教育厅</a>
                </li>
                <li>
                  <a href="http://www.fjszhzjs.cn/" target="_blank">福建省中华职业教育社</a>
                </li>
                <li>
                  <a href="http://www.class.com.cn/" target="_blank">
                    中国人力资源和社会保障出版集团有限公司
                  </a>
                </li>
                 <li>
                  <a href="https://www.fjscjzw.com/#/" target="_blank">
                    福建省创新创业创造教育指导委员会
                  </a>
                </li>
              </ul>
            </div>
            <div class="shortcut">
              <p>技术支持</p>
              <ul class="link-list">
                <li>
                  <a href="https://www.qcweilai.com/" target="_blank">青创未来集团</a>
                </li>
                <li>
                  <a href="http://www.11ready.com/plus/list.php?tid=551" target="_blank">
                    福建省汇众创新创业研究院
                  </a>
                </li>
              </ul>
            </div>
            {/*
                <div class="shortcut">
          				<p>更多服务</p>
          				<ul class="link-list">
          					<li><a href="#">赛事指导</a></li>
          				</ul>
          			</div>
              */}
            <div class="shortcut">
              <p>联系我们</p>
              <ul class="link-list">
                <li>
                  <a href="javascript:void(0)">龚老师：18120967669</a>
                </li>
                <li>
                  <a href="javascript:void(0)">张老师：13696886556</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="right">
            <img src={codeImg} />
            <span>关注我们</span>
          </div>
        </div>
        <p class="bottom">
          <a href="http://beian.miit.gov.cn" target="_blank">闽ICP备16026330号-8</a>
        </p>
      </div>
    );
  }
}
